var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutFluDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 663,
    viewBox: "0 0 548 663",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M393.222 283.326C318.036 282.173 212.81 242.193 245.272 183.86C277.654 125.672 286.229 54.1621 393.222 52.326C500.215 54.1621 508.791 125.672 541.173 183.86C573.635 242.193 468.409 282.173 393.222 283.326Z",
    fill: "#81A1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M354.135 244.326C278.883 243.171 173.564 203.135 206.055 144.72C238.465 86.4497 247.048 14.8387 354.135 13C461.222 14.8387 469.806 86.4497 502.216 144.72C534.706 203.135 429.388 243.171 354.135 244.326Z",
    stroke: "#4C566A",
    strokeWidth: 25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M314.638 105.12V138.457",
    stroke: "#4C566A",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M393.633 105.12V138.457",
    stroke: "#4C566A",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M383.828 663C346.15 662.424 293.419 642.458 309.687 613.327C325.914 584.268 330.211 548.556 383.828 547.639C437.444 548.556 441.741 584.268 457.968 613.327C474.236 642.458 421.505 662.424 383.828 663Z",
    fill: "#EBCB8B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M364.24 643.524C326.53 642.947 273.753 622.953 290.034 593.781C306.276 564.681 310.577 528.918 364.24 528C417.904 528.918 422.205 564.681 438.446 593.781C454.728 622.953 401.951 642.947 364.24 643.524Z",
    stroke: "#4C566A",
    strokeWidth: 13
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M344.447 574.004V590.653",
    stroke: "#4C566A",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M384.033 574.004V590.653",
    stroke: "#4C566A",
    strokeWidth: 13,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7919 490C148.513 489.253 216.699 463.372 195.664 425.609C174.68 387.94 169.123 341.647 99.7919 340.458C30.4606 341.647 24.9034 387.94 3.92009 425.609C-17.1153 463.372 51.0711 489.253 99.7919 490Z",
    fill: "#B48EAD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.12 464.753C173.884 464.005 242.13 438.087 221.076 400.271C200.075 362.549 194.513 316.19 125.12 315C55.7281 316.19 50.166 362.549 29.1643 400.271C8.11043 438.087 76.3568 464.005 125.12 464.753Z",
    stroke: "#4C566A",
    strokeWidth: 17
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.715 374.635V396.217",
    stroke: "#4C566A",
    strokeWidth: 17,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.526 374.635V396.217",
    stroke: "#4C566A",
    strokeWidth: 17,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutFluDesktop);
export default __webpack_public_path__ + "static/media/about-flu-desktop.f5e25edcc896d2c73ee2d1967c033b8a.svg";
export { ForwardRef as ReactComponent };